export default function History(){
    return (
        <div className="main-div">
        <div className="main-content">
            
            <div className="video-listing">

                <div className="video-card">
                    <img src="https://i.ytimg.com/vi/TUVcZfQe-Kw/mqdefault.jpg" />
                    <div className="video-details">
                        <img
                            src="https://yt3.ggpht.com/ytc/AKedOLQFII48R0atMndxGz1n5quE7W1VIpMvJxNnGlUYFg=s68-c-k-c0x00ffffff-no-rj" />
                        <div className="video-texts">
                            <h3 className="video-title">Learn JavaScript today fewfregvrsrdgrsgfdg</h3>
                            <p>JavaScript.io</p>
                            <p>36K views</p>
                        </div>
                    </div>
                </div>

                <div className="video-card">
                    <img src="https://i.ytimg.com/vi/TUVcZfQe-Kw/mqdefault.jpg" />
                    <div className="video-details">
                        <img
                            src="https://yt3.ggpht.com/ytc/AKedOLQFII48R0atMndxGz1n5quE7W1VIpMvJxNnGlUYFg=s68-c-k-c0x00ffffff-no-rj" />
                        <div className="video-texts">
                            <h3 className="video-title">Learn JavaScript today fewfregvrsrdgrsgfdg</h3>
                            <p>JavaScript.io</p>
                            <p>36K views</p>
                        </div>
                    </div>
                </div>

            </div>

            

        </div>
        </div>
    )
}